/** 题型定义（新编辑器内部模型，与 form-generator 解耦） */

export const TYPE_META = {
  desc: { name: '作业说明', icon: 'el-icon-document' },
  qa: { name: '问答题', icon: 'el-icon-chat-dot-round' },
  attach: { name: '附件题', icon: 'el-icon-paperclip' },
  tf: { name: '判断题', icon: 'el-icon-circle-check' },
  single: { name: '单选题', icon: 'el-icon-success' },
  multi: { name: '多选题', icon: 'el-icon-finished' }
}

export const TYPE_GROUPS = [
  {
    label: '作业说明',
    types: ['desc']
  },
  {
    label: '主观题',
    types: ['qa', 'attach']
  },
  {
    label: '客观题',
    types: ['tf', 'single', 'multi']
  }
]

export const ATTACH_FORMATS = [
  { value: 'any', label: '不限制', ext: '全部格式' },
  { value: 'doc', label: 'Word', ext: '.doc/.docx', accept: '.doc,.docx' },
  { value: 'pdf', label: 'PDF', ext: '.pdf', accept: '.pdf' },
  { value: 'ppt', label: 'PPT', ext: '.ppt/.pptx', accept: '.ppt,.pptx' },
  { value: 'xls', label: 'Excel', ext: '.xls/.xlsx', accept: '.xls,.xlsx' },
  { value: 'zip', label: '压缩包', ext: '.zip/.rar', accept: '.zip,.rar' },
  { value: 'image', label: '图片', ext: '.jpg/.png', accept: '.jpg,.jpeg,.png' },
  { value: 'audio', label: '音频', ext: '.mp3/.wav', accept: '.mp3,.wav' },
  { value: 'video', label: '视频', ext: '.mp4', accept: '.mp4' }
]

export const DEFAULT_OPTIONS = [
  { label: '', value: 'A' },
  { label: '', value: 'B' },
  { label: '', value: 'C' },
  { label: '', value: 'D' }
]

export const TF_OPTIONS = [
  { label: '正确', value: '正确' },
  { label: '错误', value: '错误' }
]

let localId = 100

export const nextFormId = () => {
  localId += 1
  return localId
}

export const syncFormIdSeed = (list = []) => {
  let max = 100
  list.forEach((item) => {
    const id = item.__config__ && item.__config__.formId
    if (id && id > max) max = id
  })
  localId = max
}

export const createEmptyQuestion = (type) => {
  const formId = nextFormId()
  const base = {
    id: formId,
    type,
    vModel: `field${formId}`,
    title: '',
    titleUrl: '', // 题目配图 md5，仅一张
    score: null,
    resolve: '',
    power: [],
    powerValue: [],
    answer: type === 'multi' ? [] : '',
    options: type === 'single' || type === 'multi' ? DEFAULT_OPTIONS.map((o) => ({ ...o })) : [],
    templateMd5: '',
    templateName: '',
    formats: ['any']
  }
  if (type === 'tf') {
    base.options = TF_OPTIONS.map((o) => ({ ...o }))
  }
  return base
}

export const createDefaultSettings = () => ({
  workname: '',
  beginTime: '',
  endTime: '',
  isSettime: 'false',
  setTime: '120',
  edit: false,
  isLook: false,
  needStudy: false,
  subagain: false,
  subStart: '',
  subEnd: '',
  checkcommit: 'true',
  isCheck: 'true',
  score: 'true',
  fine: false,
  resolve: false,
  supportCopy: false,
  lessonId: null,
  // 主题遗留字段（提交时原样带回）
  topicType: '',
  topicname: '',
  subjectValue: '',
  topicBind: '',
  courseValue: '',
  coverUrl: ''
})

export const formatsToAccept = (formats = []) => {
  if (!formats.length || formats.includes('any')) return ''
  return ATTACH_FORMATS.filter((f) => formats.includes(f.value) && f.accept)
    .map((f) => f.accept)
    .join(',')
}

export const acceptToFormats = (accept = '') => {
  if (!accept || !String(accept).trim()) return ['any']
  const parts = String(accept)
    .toLowerCase()
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
  const matched = ATTACH_FORMATS.filter((f) => {
    if (!f.accept) return false
    const exts = f.accept.split(',').map((s) => s.trim().toLowerCase())
    return exts.some((ext) => parts.includes(ext))
  }).map((f) => f.value)
  return matched.length ? matched : ['any']
}
